import {CheckboxCheckedIcon,CheckboxIcon} from "../../assets/icon";

export default function Checkbox({
    checked=false,
    onChange
                                 }:{
    checked?:boolean,
    onChange?:(checked:boolean)=>void
}){
    return checked ? <CheckboxCheckedIcon onClick={()=>onChange?.(false)}/> : <CheckboxIcon onClick={()=>onChange?.(true)}/>
}